// extracted by mini-css-extract-plugin
module.exports = {"virtual-assistant":"virtual-assistant___1JGcL","is-in-iframe":"is-in-iframe___2KItC","evaluation-audio":"evaluation-audio___13KPh","evaluation-vedio":"evaluation-vedio___27h3Z"};